import script from "./players.vue?vue&type=script&setup=true&lang=js"
export * from "./players.vue?vue&type=script&setup=true&lang=js"

import "./players.vue?vue&type=style&index=0&id=d02d4224&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d02d4224"]])

export default __exports__